import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import CloseIcon from 'dibs-vg/dist/react/close';
import get from 'lodash.get';
import RemoveModal from './CartRemoveModal';
import { cartItemRemoveMutation } from '../mutations/cartItemRemoveMutation';

import styles from './styles/CartRemoveItemLink.scss';

class CartRemoveItemLink extends Component {
    constructor() {
        super();

        this.onDelete = this.onDelete.bind(this);

        this.state = {
            showModal: false,
            isLoading: false,
            hasError: false,
        };
    }
    onDelete() {
        const { relay, viewer, user, portfolioItem } = this.props;
        const portfolioId = get(portfolioItem, 'portfolioId');
        const portfolioItemId = get(portfolioItem, 'portfolioItemId');
        const portfolioItemRelayId = get(portfolioItem, 'id');

        this.setState({ isLoading: true });

        cartItemRemoveMutation(relay.environment, {
            viewerId: viewer.id,
            userId: user.serviceId,
            portfolioId,
            portfolioItemId,
            portfolioItemRelayId,
        });
    }
    render() {
        const { showModal, isLoading, hasError } = this.state;
        return (
            <div
                className={styles.container}
                data-tn="cart-remove-link"
                onClick={() => this.setState({ showModal: true })}
            >
                <CloseIcon />
                <RemoveModal
                    showModal={showModal}
                    isLoading={isLoading}
                    hasError={hasError}
                    onClose={() => this.setState({ showModal: false })}
                    onClick={this.onDelete}
                />
            </div>
        );
    }
}

CartRemoveItemLink.propTypes = {
    relay: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
    portfolioItem: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
};

export default createFragmentContainer(CartRemoveItemLink, {
    viewer: graphql`
        fragment CartRemoveItemLink_viewer on Viewer {
            id
        }
    `,
    user: graphql`
        fragment CartRemoveItemLink_user on User {
            serviceId
        }
    `,
    portfolioItem: graphql`
        fragment CartRemoveItemLink_portfolioItem on PortfolioItemV2 {
            id
            portfolioId
            portfolioItemId
        }
    `,
});
